const routes = {
  login: "/login",
  register: "/register",
  launch: "/",
  profile: {
    root: "/profile",
    skills: "/profile/skills",
    achievements: "/profile/achievements",
  },
  explore: { root: "/explore", project: "/explore/:id" },
  projects: {
    root: "/projects",
    new: "/projects/new",
    project: "/projects/:id",
    edit: "/projects/edit/:id",
  },
};

export default routes;
